export const CROSSWORD = 'crossword';
export const RECIEPT_REQUIRED = 'purchaserequired';
export const RECEIPT_NOT_REQUIRED = 'purchasenotrequired';
export const MY_WAITROSE = 'mywaitrose';
//# sourceMappingURL=competition-forms.js.map